import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Stack, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Button, TextField, Autocomplete, MenuItem, Menu, InputAdornment, CircularProgress } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useHistory } from 'react-router-dom';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { CurrencySymbol } from '../../../Utility/Constants';
import { Colors } from '../../../Styles/Colors';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { CommonCorporateAndInsuranceDetails } from '../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountFormat, CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { DateTime } from 'luxon';
import { useLocation } from 'react-router-dom'

const List = [
    {
        product_name: '',
        department: '',
        category: '',
        sub_categroy: '',
        product_type: '',
        batch_no: '',
        expiry_date: '',
        cost_per_quantity: '',
        available_qty: '',
        quantity: '',
        discount_amount: "",
        discount_percentage: "",
        total_amount: '',
        product_sugg_list: []
    }
]
const rejecDetails = {
    vendorName: null,
    invoiceNumber: '',
    returnDateTime: new Date(Date.now()),
    cgst: '',
    sgst: '',
    billAmt: '',
}
const StorePurchaseRejectionAdd = () => {
    const history = useHistory()
    const location = useLocation();
    const [detailsRejec, setdetailRejec] = useState(rejecDetails)
    const [dateTimerOpen, setDateTimerOpen] = useState(false);
    const [productTblData, setproductTblData] = useState(List || []);
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [isErrorMsgText, setisErrorMsgText] = useState('')
    const [SuccessMsgText, setSuccessMsgText] = useState('')
    const [vendorList, setvendorList] = useState([]);
    const [isEdit, setisEdit] = useState(false);
    const [ProductNameAnchor, setProductNameAnchor] = useState(null);
    const [focusDrugList, setFocusDrugList] = useState(false);
    const [searchingDrugIndex, setSearchingDrugIndex] = useState(null);
    const [productNameCurrentIndex, setproductNameCurrentIndex] = useState(null);
    const [BatchAnchor, setBatchAnchor] = useState(null);
    const [CurrentBatchIndex, setCurrentBatchIndex] = useState(null);
    const [SearchingBatchIndex, setSearchingBatchIndex] = useState(null);
    const [totalDiscount, settotalDiscount] = useState([]);
    const [netAmount, setnetAmount] = useState(0);
    const [RoundOffednetAmount, setRoundOffednetAmount] = useState(0);
    const [TaxableAmount, setTaxableAmount] = useState(0);
    const [drugDetailsData, setdrugDetailsData] = useState([]);
    const productNameRef = useRef(null);
    const BatchNameRef = useRef(null);
    const QuantityRef = useRef(null);
    const [QuantityCurrentIndex, setQuantityCurrentIndex] = useState(null)

    useEffect(() => {
        if (location?.states?.purchase_rejection_data) {
            let Data = location?.states?.purchase_rejection_data
            setRoundOffednetAmount(Data?.net_amount || 0)
            setTaxableAmount(Data?.taxable_amount || 0)
            let LineItem = []
            Data?.line_items?.forEach((item) => {
                LineItem.push({
                    product_name: item?.product_name || "-",
                    department: item?.department_name || "-",
                    category: item?.category_name || "-",
                    sub_categroy: item?.sub_category_name || "-",
                    product_type: item?.product_type_name || "-",
                    batch_no: item?.batch_no || "-",
                    expiry_date: item?.expiry_date || "-",
                    buying_price_per_quantity: +item?.buying_price_per_quantity || 0,
                    available_qty: +item?.stock_in_quantity || 0,
                    quantity: +item?.return_quantity || 0,
                    discount_percentage: +item?.discount_percentage || 0,
                    discount_amount: +item?.discount_amount || 0,
                    total_return_price: +item?.taxable_amount || 0,
                    total_price: +item?.net_amount || 0,
                })
            })
            setproductTblData(LineItem)
            setisEdit(true)
            getVendorDetails(Data)
        } else {
            getVendorDetails()
        }
    }, [])

    const getVendorDetails = (PurRejData = null) => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_VENDOR)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorList(response.data.data)
                        if (PurRejData) {
                            setdetailRejec({
                                vendorName: response?.data?.data?.find((list) => list?.id === PurRejData?.vendor_id),
                                invoiceNumber: PurRejData?.invoice_number || "",
                                returnDateTime: new Date(PurRejData?.return_date).toISOString().split("T")[0],
                                cgst: '',
                                sgst: '',
                                billAmt: '',
                            })
                        }
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteLineItems = (index = null) => {
        let EmptyList = {
            product_name: '',
            department: '',
            category: '',
            sub_categroy: '',
            product_type: '',
            batch_no: '',
            expiry_data: '',
            cost_per_quantity: '',
            available_qty: '',
            quantity: '',
            discount_amount: "",
            discount_percentage: "",
            total_amount: '',
            product_sugg_list: []
        }
        if (index !== null) {
            if (productTblData?.length - 1 === index) {
                let tblData = productTblData
                tblData[productTblData?.length - 1] = EmptyList
                setproductTblData(tblData);
            } else {
                setproductTblData(productTblData.filter((_, i) => i !== index));
            }
        } else {
            setproductTblData([EmptyList]);
        }
    };
    const handleproductChange = (index, item) => (e) => {
        let value = e.target.value;
        let updatedData = [...productTblData];

        if (value !== "") {
            updatedData[index] = {
                ...updatedData[index],
                product_name: value,
                department: '',
                category: '',
                sub_categroy: '',
                product_type: '',
                batch_no: '',
                expiry_date: '',
                cost_per_quantity: '',
                available_qty: '',
                quantity: '',
                discount_amount: "",
                discount_percentage: "",
                total_amount: '',
                product_sugg_list: [],
            };
            delete updatedData[index].product_sugg_list;
            setproductTblData(updatedData);

            if (CommonValidation.removeSpace(value)?.length > 2) {
                setproductNameCurrentIndex(index);
                getProductDetails(index);
            }
        } else if (value === "" && index !== (productTblData.length - 1)) {
            updatedData.splice(index, 1);
            setproductTblData(updatedData);
        } else {
            updatedData[index].product_name = value;
            setproductTblData(updatedData);
        }
    };

    const DrugSearchLoader = (index) => {
        setSearchingDrugIndex(index)
    }

    const getProductDetails = (index) => {
        try {
            if (!productTblData[index]?.product_name?.trim()) {
                return errorMessage("Enter Product Name");
            }

            DrugSearchLoader(index);
            let brandName = (productTblData[index]['product_name'] || "").replaceAll('&', '%26');

            RestAPIService.getAll(Serviceurls.STORE_PRODUCT + `?product_name=${CommonValidation.removeSpace(brandName)}`)
                .then((response) => {
                    DrugSearchLoader(null);
                    if (response.data.status === 'success') {
                        if (response.data?.data?.length) {
                            const updatedData = [...productTblData];
                            updatedData[index]['product_sugg_list'] = response.data.data;
                            setproductTblData(updatedData);
                        } else {
                            errorMessage("No Product Found");
                        }
                    } else {
                        errorMessage(response?.data?.message);
                    }
                })
                .catch((error) => {
                    DrugSearchLoader(null);
                    errorMessage(error?.response?.data?.message || "An unexpected error occurred");
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };


    const onAddHandler = (names, index) => {
        try {
            if (!productTblData[index]?.product_name?.trim()) {
                return errorMessage('Enter All Fields');
            }

            if (names === 'quantity' || names === 'discount') {
                if (index === (productTblData?.length || 0) - 1) {
                    let duplicateTbl = {
                        product_name: '',
                        department: '',
                        category: '',
                        sub_categroy: '',
                        product_type: '',
                        batch_no: '',
                        expiry_date: '',
                        cost_per_quantity: '',
                        available_qty: '',
                        quantity: '',
                        discount_amount: "",
                        discount_percentage: "",
                        total_amount: '',
                        product_sugg_list: []
                    };

                    setproductTblData([...productTblData, duplicateTbl]);
                    setdrugDetailsData([]);
                }
            }
        } catch (error) {
            errorMessage(error?.message || "An unexpected error occurred");
        }
    };


    const autocompleteOnChangeHandler = (newValue, names, index) => {
        try {
            let updatedTblData = [...productTblData];

            switch (names) {
                case 'product_name':
                    updatedTblData[index] = {
                        ...updatedTblData[index],
                        product_id: newValue['id'],
                        product_name: newValue['product_name'],
                        department: newValue['department_name'],
                        category: newValue['category_name'],
                        sub_categroy: newValue['sub_category_name'],
                        product_type: newValue['product_type_name'],
                        expiry_date: '',
                        cost_per_quantity: '',
                        available_qty: '',
                        quantity: '',
                        discount_amount: "",
                        discount_percentage: "",
                        total_amount: '',
                        total_cost: "",
                        total_price: "",
                        id: newValue['id']
                    };

                    setproductTblData(updatedTblData);
                    setQuantityCurrentIndex(index);
                    getDrugDetailsData(index, updatedTblData);
                    break;

                case 'batch_no':
                    const batchSelected = updatedTblData.some(
                        element =>
                            element?.batch_no === newValue['batch_no'] &&
                            element?.drug_id === newValue['product_id'] &&
                            element?.expiry_date === newValue['expiry_date'] &&
                            element?.cost_per_quantity === newValue['cost_per_quantity']
                    );

                    if (batchSelected) {
                        errorMessage(`${newValue['batch_no']} Batch No Already Exists`);
                    } else {
                        updatedTblData[index] = {
                            ...updatedTblData[index],
                            batch_no: newValue['batch_no'],
                            expiry_date: newValue['expiry_date'],
                            cost_per_quantity: newValue['mrp_per_quantity'],
                            available_qty: newValue['stock_in_quantity'],
                            stock_entry_id: newValue['stock_entry_id'],
                            id: newValue['id'],
                            buying_price_per_quantity: +newValue['buying_price_per_quantity'],
                            total_cost: "",
                            total_price: "",
                            quantity: '',
                            discount_amount: "",
                            discount_percentage: newValue['discount_percentage'] ? newValue['discount_percentage'] : "",
                            total_amount: '',
                        };

                        setproductTblData(updatedTblData);
                        setQuantityCurrentIndex(index);
                        setBatchAnchor(null);
                        setCurrentBatchIndex(null);
                    }
                    break;

                default:
                    break;
            }
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const calculateCostAndTotal = (value, index, FromReturn = false) => {
        try {
            let updatedTblData = [...productTblData];

            updatedTblData[index]['total_cost'] = parseFloat(+value * +updatedTblData[index]['buying_price_per_quantity']).toFixed(2);
            let totalCost = parseFloat(updatedTblData[index]['total_cost']);
            updatedTblData[index]['total_return_price'] = totalCost;
            // updatedTblData[index]['total_price'] = updatedTblData[index]['cgst_percentage'] ? CommonValidation.CalculateGSTInclude(totalCost, (updatedTblData[index]['cgst_percentage'] * 2)) : totalCost;;
            setproductTblData(updatedTblData);
            calculateDiscountTotalPrice(index);
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const calculateDiscountTotalPrice = (index, fromAmount = false) => {
        try {
            let updatedTblData = [...productTblData];
            let totalCost = updatedTblData[index]['total_return_price'];

            if (fromAmount) {
                let discountValue = +updatedTblData[index]['discount_amount'];
                updatedTblData[index]['discount_percentage'] = CommonValidation.amountPercentageWithoutRoundoff(
                    discountValue,
                    totalCost
                );
                updatedTblData[index]['discount_percentage_w_r'] = CommonValidation.amountPercentage(
                    discountValue,
                    totalCost
                );
                updatedTblData[index]['total_price'] = updatedTblData[index]['cgst_percentage'] ? CommonValidation.CalculateGSTInclude((totalCost - discountValue), (updatedTblData[index]['cgst_percentage'] * 2)) : totalCost;;
            } else {
                let discount = updatedTblData[index]['discount_percentage'];
                let discountValue = (discount && totalCost) ? CommonValidation.calculatePercentageWithoutRoundoff(discount, totalCost) : 0;
                updatedTblData[index]['discount_amount'] = discount ? discountValue : "";
                updatedTblData[index]['total_price'] = updatedTblData[index]['cgst_percentage'] ? CommonValidation.CalculateGSTInclude((totalCost - discountValue), (updatedTblData[index]['cgst_percentage'] * 2)) : totalCost;;
            }

            setproductTblData(updatedTblData);
        } catch (error) {
            errorMessage(error.message);
        }
    };


    const renderDrugColumn = (index, item) => {
        return (
            <Box>
                <Tooltip title={item.product_name?.length > 18 ? item.product_name : ""} placement="top" arrow>
                    <TextField
                        inputRef={productNameRef}
                        size='small'
                        variant='standard'
                        autoComplete='off'
                        value={item.product_name}
                        disabled={isEdit}
                        onChange={handleproductChange(index, item)}
                        sx={{ width: '8vw' }}
                        onKeyDown={(e) => {
                            setProductNameAnchor(e.currentTarget);
                            setFocusDrugList(e.key === "ArrowDown");
                            if (e.key === 'Enter' && item.product_name?.length > 2) {
                                setproductNameCurrentIndex(index);
                                getProductDetails(index);
                            }
                        }}
                        inputProps={{ emed_tid: "bill_product_name", paddingLeft: '0.4vw' }}
                        InputProps={{
                            endAdornment: searchingDrugIndex === index ? <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment> : null,
                        }}
                    />
                </Tooltip>
                <Menu
                    open={productNameCurrentIndex === index && item.product_sugg_list?.length > 0 && item.product_name !== ""}
                    className="eMed_Drug_Sugg_Pop"
                    anchorEl={ProductNameAnchor}
                    onClose={() => setproductNameCurrentIndex(null)}
                    autoFocus={false}
                    disableAutoFocusItem
                    disableAutoFocus
                >
                    <Box width={"26vw"}>
                        <Box sx={{ display: 'flex', backgroundColor: Colors.ThemeLightColor, paddingY: '0.3vw' }}>
                            <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"} >Product Code</Typography>
                            <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Product Details</Typography>
                            {/* <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Avl Qty</Typography> */}
                        </Box>
                        <Box maxHeight={'14vw'} overflow={'scroll'}>
                            {item.product_sugg_list?.map((list, Drugindex) => (
                                <MenuItem
                                    key={Drugindex}
                                    emed_tid="bill_drug_sugg_li"
                                    autoFocus={focusDrugList && Drugindex === 0}
                                    onKeyDown={(e) => {
                                        if (Drugindex === item.product_sugg_list.length - 1 && e.key === "ArrowDown") {
                                            e.stopPropagation();
                                        } else if (Drugindex === 0 && e.key === "ArrowUp") {
                                            e.stopPropagation();
                                            setproductNameCurrentIndex(index);
                                        }
                                    }}
                                    onClick={() => {
                                        setproductNameCurrentIndex(null);
                                        onAddHandler("quantity", index);
                                        autocompleteOnChangeHandler(list, "product_name", index);
                                    }}
                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                >
                                    <Typography width={"25%"} fontSize={"0.8vw"}>{list?.product_code}</Typography>
                                    <Box width={"50%"}>
                                        <CommonCorporateAndInsuranceDetails data={list} fromStorPurRejec={true} />
                                    </Box>
                                    {/* <Typography width={"25%"}    fontSize={"0.8vw"} >{list?.roq_quantity}</Typography> */}
                                </MenuItem>
                            ))}
                        </Box>
                    </Box>
                </Menu>
            </Box>
        );
    };
    const BatchearchLoader = (index) => {
        setSearchingBatchIndex(index)
    }

    const getDrugDetailsData = async (index, updatedTblData) => {
        try {
            setSearchingBatchIndex(index);
            let QueryParams = `?id=${updatedTblData[index]?.id || ''}`;
            const response = await RestAPIService.getAll(Serviceurls.STORE_BATCH_SEARCH + QueryParams);

            if (response.data.status === 'success') {
                let batchList = response.data.data || [];
                let updatedData = [...updatedTblData];
                updatedData[index].product_sugg_list = batchList;

                if (batchList.length > 0) {
                    let selectedBatch = batchList.find(batch => !updatedData.some(item => item.batch_no === batch.batch_no)) || batchList[0];

                    updatedData[index] = {
                        ...updatedData[index],
                        batch_no: selectedBatch['batch_no'],
                        stock_entry_id: selectedBatch['stock_entry_id'],
                        cgst_percentage: selectedBatch['cgst_percentage'],
                        sgst_percentage: selectedBatch['cgst_percentage'],
                        expiry_date: selectedBatch['expiry_date'],
                        cost_per_quantity: selectedBatch['mrp_per_quantity'],
                        available_qty: selectedBatch['stock_in_quantity'],
                        id: selectedBatch['id'],
                        buying_price_per_quantity: +selectedBatch['buying_price_per_quantity'],
                        total_cost: "",
                        total_price: "",
                        discount_percentage: selectedBatch['discount_percentage'] ? selectedBatch['discount_percentage'] : "",
                    };
                }

                setproductTblData([...updatedData, ...List]);
                setQuantityCurrentIndex(index);
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error.message);
        } finally {
            setSearchingBatchIndex(null);
        }
    };


    const renderBatchColumn = (index, item) => {
        return (
            <Box>
                <TextField
                    inputRef={BatchNameRef}
                    disabled={isEdit}
                    size='small'
                    variant='standard'
                    autoComplete='off'
                    value={item.batch_no}
                    onKeyDown={(e) => {
                        e.preventDefault()
                        // this.setState({ BatchAnchor: e.currentTarget })
                    }}
                    onFocus={(e) => {
                        setBatchAnchor(e.currentTarget)
                        setCurrentBatchIndex(index)
                        e.preventDefault()
                        if ((!productTblData[index]['product_sugg_list'])) {
                            getDrugDetailsData(index)
                        }
                    }}
                    inputProps={{ emed_tid: "bill_batch_name", style: { paddingLeft: '0.4vw' } }}
                    InputProps={{
                        endAdornment: SearchingBatchIndex === index ? <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment> : <InputAdornment position="end"><ArrowDropDownIcon size={15} /></InputAdornment>,
                    }}

                />
                <Menu
                    open={CurrentBatchIndex === index}
                    className="eMed_Drug_Sugg_Pop"
                    anchorEl={BatchAnchor}
                    onClose={() => {
                        setBatchAnchor(null)
                        setCurrentBatchIndex(null)
                    }}
                    autoFocus={true}
                    disableAutoFocusItem
                    disableAutoFocus
                    disableRestoreFocus
                >
                    <Box width={"30vw"} >
                        <Box sx={{ display: 'flex', backgroundColor: Colors.ThemeLightColor, paddingY: '0.4vw' }} emed_tid={"bill_batch_no_items"}>
                            <Typography width={"35%"} fontWeight={600} fontSize={'0.8vw'} paddingLeft={'1vw'}>Batch No</Typography>
                            <Typography width={"20%"} fontWeight={600} fontSize={'0.8vw'} >Expiry Date</Typography>
                            <Typography width={"25%"} fontWeight={600} fontSize={'0.8vw'}>Avl/Qty</Typography>
                            <Typography width={"20%"} fontWeight={600} fontSize={'0.8vw'} >BP /Qty</Typography>
                        </Box>
                        <Box maxHeight={'14vw'} overflow={'scroll'}>
                            {
                                (item.product_sugg_list && item.product_sugg_list.length > 0) ?
                                    item.product_sugg_list.map((list, Drugindex) => {
                                        var datePart = list?.expiry_date ? list?.expiry_date?.match(/\d+/g) : []
                                        var ExpiryDate = datePart.length === 3 ? datePart[1] + '-' + datePart[0] : "-";
                                        return (
                                            <MenuItem
                                                onKeyDown={(e) => {
                                                    if (Drugindex === item.product_sugg_list.length - 1 && e.key === "ArrowDown") { e.stopPropagation() }
                                                    else if (Drugindex === 0 && e.key === "ArrowUp") {
                                                        e.stopPropagation()
                                                        // this.setState({ DurgNameCurrentIndex: index })
                                                    }
                                                }}
                                                emed_tid={`batch_suggestion`}
                                                key={Drugindex}
                                                autoFocus={true}
                                                onClick={() => { autocompleteOnChangeHandler(list, 'batch_no', index) }}
                                                sx={[{ display: 'flex', flexDirection: 'row', backgroundColor: list.batch_expiry_alert ? '#EE9E4F' : 'white', '&:hover': list.batch_expiry_alert ? { backgroundColor: '#f0bc89' } : null }]}>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', width: "100%" }}>
                                                    {list?.batch_no ? list?.batch_no?.length > 12 ?
                                                        <Tooltip placement='top' title={list?.batch_no} arrow>
                                                            <Typography width={"35%"} fontSize={'0.8vw'}>{list?.batch_no?.slice(0, 10) + "..."}</Typography>
                                                        </Tooltip>
                                                        : <Typography width={"35%"} fontSize={'0.8vw'}>{list?.batch_no}</Typography> : "-"}
                                                    <Typography width={"20%"} fontSize={'0.8vw'}>{ExpiryDate}</Typography>
                                                    <Typography width={"25%"} fontSize={'0.8vw'}>{list?.stock_in_quantity}</Typography>
                                                    <Typography width={"20%"} fontSize={'0.8vw'} textAlign={'center'}>{list?.buying_price_per_quantity || 0}</Typography>
                                                </Box>
                                            </MenuItem>
                                        )
                                    }) : <Typography textAlign={"center"} paddingY={"0.5vw"} width={"100%"} fontSize={'0.8vw'}>{"No Batches Found"}</Typography>
                            }
                        </Box>
                    </Box>
                </Menu>
            </Box>
        )
    };

    const inputTextBox = (values, names, labels, width, index, height, disable) => {
        return (
            <TextField
                inputRef={(names === "quantity" && QuantityCurrentIndex === index) ? QuantityRef : null}
                autoFocus
                size="small"
                variant="standard"
                sx={{ width: width }}
                placeholder={labels}
                disabled={!(
                    productTblData[index]?.product_name &&
                    productTblData[index]?.department &&
                    productTblData[index]?.category &&
                    productTblData[index]?.batch_no
                ) || isEdit}
                onKeyDown={(e) => { if (e.key === "Enter") { this.DrugNameRef?.current.focus(); } }}
                name={names}
                autoComplete="off"
                inputProps={{
                    emed_tid: labels,
                    style: {
                        height: height || "2vh",
                        marginTop: "0.5vw",
                        textAlign: "center",
                        color: (names === "quantity" && productTblData[index]?.product_name)
                            ? (productTblData[index]["available_qty"] < productTblData[index]["quantity"] || !productTblData[index]["available_qty"])
                                ? "red"
                                : null
                            : null
                    }
                }}
                value={values}
                onChange={(e) => onChangeHandler(e, index)}
                error={(names === "quantity" && productTblData[index]?.product_name)
                    ? (productTblData[index]["available_qty"] < productTblData[index]["quantity"] || !productTblData[index]["available_qty"])
                    : null
                }
            />
        );
    };

    const onChangeHandler = (e, index) => {
        try {
            const { name, value } = e.target;
            const updatedData = [...productTblData]; // ✅ Create a new array to avoid state mutation

            // Helper function to safely convert value to number
            const toNumber = (value) => {
                return value === "" || value === "0" ? 0 : parseFloat(value) || 0;
            };

            switch (name) {
                case "quantity":
                    if (updatedData[index]?.product_name) {
                        if ((CommonValidation.numberOnly(value) && value.length < 6) && (value !== "0")) {
                            updatedData[index]["quantity"] = value;
                            // updatedData[index]["total_cost"] = (updatedData[index]["cost_per_quantity"] * (value ? +value : 1));
                            setproductTblData(updatedData); // ✅ Correctly updating state
                            calculateCostAndTotal(value, index, true);
                        } else if (value === "" || value === "0") {
                            updatedData[index]["quantity"] = "";
                            updatedData[index]["total_cost"] = 0;
                            updatedData[index]["total_return_price"] = 0;
                            updatedData[index]["total_price"] = 0;
                            updatedData[index]["discount_amount"] = "";

                            settotalDiscount(0);
                            setproductTblData(updatedData);
                        }
                    } else {
                        errorMessage("Select Brand Name");
                    }
                    break;

                case "discount_percentage":
                    if (updatedData[index]?.product_name) {
                        const discountValue = toNumber(value);
                        if ((CommonValidation.DecimalNumber(value) && discountValue <= 100) || value === "" || value === "0") {
                            updatedData[index]["discount_percentage"] = +discountValue.toFixed(2);
                            updatedData[index]["discount_percentage_w_r"] = +discountValue.toFixed(2);
                            setproductTblData(updatedData);
                            calculateDiscountTotalPrice(index);
                        }
                    } else {
                        errorMessage("Select Brand Name");
                    }
                    break;

                case "discount_amount":
                    if (updatedData[index]?.product_name) {
                        const totalCost = toNumber(updatedData[index]["total_cost"]);
                        const discountValue = toNumber(value);
                        if ((CommonValidation.NumberWithDot(value) && discountValue <= totalCost) || value === "" || value === "0") {
                            updatedData[index]["discount_amount"] = discountValue;
                            setproductTblData(updatedData);
                            calculateDiscountTotalPrice(index, true);
                        }
                    } else {
                        errorMessage("Select Brand Name");
                    }
                    break;

                default:
                    break;
            }
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const postPurchaseReturn = () => {
        try {
            if (!detailsRejec?.vendorName?.id || !detailsRejec?.invoiceNumber) {
                errorMessage('Please Enter All mandatory fields')
            }
            else {
                let LineItems = []
                productTblData?.forEach((list) => {
                    if (list?.quantity && list?.product_id)
                        LineItems.push({
                            "stock_id": list?.stock_entry_id,
                            "product_id": list?.product_id,
                            "net_amount": +list?.total_price || 0,
                            "cgst_percentage": +list?.sgst_percentage || 0,
                            "sgst_percentage": +list?.sgst_percentage || 0,
                            "return_quantity": +list?.quantity || 0,
                            "taxable_amount": +list?.total_return_price || 0,
                            "discount_percentage": +list?.discount_percentage || 0,
                            "discount_amount": +list?.discount_amount || 0
                        })
                })
                let startDate = new Date(detailsRejec?.returnDateTime)
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                const invoice_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")}` : ""
                let data = {
                    "vendor_id": detailsRejec?.vendorName?.id,
                    "rejection_date": invoice_date,
                    "invoice_number": detailsRejec?.invoiceNumber,
                    "taxable_amount": +TaxableAmount || 0,
                    "net_amount": +RoundOffednetAmount || 0,
                    "round_off": +billingCalculation(productTblData, 'roundOff') || 0,
                    "line_items": LineItems
                }
                RestAPIService.create(data, Serviceurls.STORE_PURCHASE_REJECTION)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            history.push({ pathname: "/StorePurchase/PurchaseRejection", states: { success_message: response.data.message } })
                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        setisErrorMsgText(msg)
        setIsErrorMsg(true);
    }
    const successMessage = (msg) => {
        setSuccessMsgText(msg)
        setSuccessMsg(true);
    }
    const msgClose = () => {
        setIsErrorMsg(false);
        setisErrorMsgText('');
        setSuccessMsg(false);
        setSuccessMsgText('')
    }

    const billingCalculation = (params = [], type) => {
        try {
            let Taxamount = params.reduce((sum, item) => sum + (+item.total_return_price || 0), 0);
            let amount = params.reduce((sum, item) => sum + (+item.total_price || 0), 0);
            let roundedAmount = Math.round(amount);
            let roundOffValue = (roundedAmount - amount).toFixed(2);

            if (netAmount !== amount) {
                setnetAmount(amount);
                setRoundOffednetAmount(roundedAmount);
                setTaxableAmount(Taxamount);
            }

            switch (type) {
                case 'totalServiceAmount':
                    return AmountFormat(roundedAmount);
                case 'Taxamount':
                    return AmountFormat(Taxamount);
                case 'roundOff':
                    return roundOffValue;
                default:
                    return 0;
            }
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const clearfunction = () => {
        setproductTblData([
            {
                product_name: '',
                department: '',
                category: '',
                sub_categroy: '',
                product_type: '',
                batch_no: '',
                expiry_date: '',
                cost_per_quantity: '',
                available_qty: '',
                quantity: '',
                discount_amount: "",
                discount_percentage: "",
                total_amount: ''
            }
        ]);
        setdetailRejec(
            {
                vendorName: null,
                invoiceNumber: '',
                returnDateTime: new Date(),
                cgst: '',
                sgst: '',
                billAmt: '',
            }
        );
        setnetAmount(0);
        setRoundOffednetAmount(0);
        setTaxableAmount(0);
    }

    return (
        <Box className='eMed_Pharma_Billing_container'>
            <Box className='eMed_Pharma_Header_Card'>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <IconButton size='small' onClick={() => history.push('/StorePurchase/PurchaseRejection')}>
                        <img className='emedhub_popupIcon_img' src={ImagePaths.LabBackButton.default} alt='Back' />
                    </IconButton>
                    <Typography sx={{ color: '#616161' }}>{'Purchase Rejection'}</Typography>
                </Stack>
            </Box>
            {console.log(productTblData)}
            <Box height='7vw' margin='0.8vw' padding='0.5vw' sx={{ backgroundColor: 'white', border: '1px solid lightgray' }}>
                <div style={{ borderBottom: '1px solid lightgray' }}>Rejection Details</div>
                <Box sx={{ display: 'flex', padding: '1vw', gap: '1vw' }}>
                    <Autocomplete
                        size='small'
                        sx={{ width: '15vw' }}
                        options={vendorList}
                        value={detailsRejec?.vendorName}
                        disabled={isEdit}
                        getOptionLabel={(option) => option?.vendor_name || ''}
                        renderInput={(params) => (
                            <TextField {...params} label={'Vendor Name' + ' *'} size='small' />
                        )}
                        onChange={(event, newValue) => {
                            setdetailRejec({ ...detailsRejec, vendorName: newValue })
                        }}
                    />
                    <TextField
                        size='small'
                        sx={{ width: '15vw' }}
                        label='Invoice Number *'
                        disabled={isEdit}
                        value={detailsRejec?.invoiceNumber}
                        onChange={(e) => setdetailRejec({ ...detailsRejec, invoiceNumber: e.target.value })}
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            disabled
                            label={'Rejection Date'}
                            value={detailsRejec?.returnDateTime}
                            onOpen={() => setDateTimerOpen(true)}
                            onClose={() => setDateTimerOpen(false)}
                            inputFormat='DD-MM-YYYY'
                            onChange={(value) => {
                                setdetailRejec({ ...detailsRejec, returnDateTime: value })
                            }}
                            renderInput={(params) => (
                                <TextField size='small' {...params} autoComplete='off' sx={{ width: '15vw' }} />
                            )}
                        />
                    </LocalizationProvider>
                    <TextField
                        size='small'
                        sx={{ width: '10vw' }}
                        label='Bill Amount'
                        value={RoundOffednetAmount}
                        disabled
                    />
                </Box>
            </Box>
            <TableContainer className='eMed_Phrama_Table_Container' sx={{ height: '45vh' }}>
                <Table stickyHeader size='small' sx={{ overflowY: 'scroll' }}>
                    <TableHead>
                        <TableRow sx={{ display: 'flex' }}>
                            <TableCell sx={{ flex: 0.01 }} className='eMed_Pharma_tbl_header'>
                                <Button emed_tid={"bill_delete_all"} className='eMed_Pharma_del_btn' onClick={() => deleteLineItems()} sx={{ visibility: isEdit ? 'hidden' : 'visible' }}>
                                    <Box component={'img'} mt={'0.2vw'} src={ImagePaths.Delete.default} alt='del' height={'1.3vw'} width={'1.3vw'} />
                                </Button>
                            </TableCell>
                            <TableCell sx={{ flex: 0.15 }} className='eMed_Pharma_tbl_header'>Product Name</TableCell>
                            <TableCell sx={{ flex: 0.078 }} align='center' className='eMed_Pharma_tbl_header'>Department</TableCell>
                            <TableCell align='center' sx={{ flex: 0.083 }} className='eMed_Pharma_tbl_header'>Category</TableCell>
                            <TableCell align='left' sx={{ flex: 0.10 }} className='eMed_Pharma_tbl_header'>Pr.Type</TableCell>
                            <TableCell align='left' sx={{ flex: 0.12 }} className='eMed_Pharma_tbl_header'>Batch No.</TableCell>
                            <TableCell sx={{ flex: 0.08 }} align='left' className='eMed_Pharma_tbl_header'>Ex.Date</TableCell>
                            <TableCell sx={{ flex: 0.08 }} align='left' className='eMed_Pharma_tbl_header'>BP/Qty</TableCell>
                            <TableCell align='center' sx={{ flex: 0.07 }} className='eMed_Pharma_tbl_header'>Avl Qty</TableCell>
                            <TableCell align='center' sx={{ flex: 0.07 }} className='eMed_Pharma_tbl_header'>Qty</TableCell>
                            <TableCell align='center' sx={{ flex: 0.09 }} className='eMed_Pharma_tbl_header'>
                                <Tooltip placement='top' title='Dicount in Percent'><div>{`Disc ( % )`}</div></Tooltip>
                            </TableCell>
                            <TableCell align='center' sx={{ flex: 0.09 }} className='eMed_Pharma_tbl_header'>
                                <Tooltip placement='top' title='Dicount in Amount'><div>{`Disc ( ${CurrencySymbol} )`}</div></Tooltip>
                            </TableCell>
                            <TableCell sx={{ flex: 0.09 }} align='center' className='eMed_Pharma_tbl_header'>{`Total Price`}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {productTblData.map((item, index) => {
                            var datePart = item?.expiry_date ? item?.expiry_date.match(/\d+/g) : []
                            var ExpiryDate = datePart ? (datePart.length === 3 ? datePart[1] + '-' + datePart[0] : "-") : "-";
                            var CategoryName = `${item?.category || "-"} - ${item?.sub_categroy}`
                            return (
                                <Tooltip title={item?.stock_in_quantity === 0 ? "No Stock Available" : ""} placement='top' arrow>
                                    <TableRow sx={{ display: 'flex', backgroundColor: item?.stock_in_quantity === 0 ? Colors.disableComponentColor : null }} key={index}>
                                        <TableCell sx={{ flex: 0.01 }}>
                                            <Button emed_tid={"bill_delete_item"} className='eMed_Pharma_del_btn' onClick={() => deleteLineItems(index)} sx={{ visibility: isEdit ? 'hidden' : 'visible' }}>
                                                <Box component={'img'} mt={'0.5vw'} src={ImagePaths.Delete.default} alt='del' height={'1.1vw'} width={'1.1vw'} />
                                            </Button>
                                        </TableCell>
                                        <TableCell sx={{ flex: 0.15 }}>{renderDrugColumn(index, item)}</TableCell>
                                        <TableCell align='center' emed_tid="bill_dosage_strength" sx={{ flex: 0.078, paddingTop: '0.8vw' }} className='eMed_Pharma_tbl_Body'>
                                            {item?.department ? item?.department?.length > 8 ?
                                                <Tooltip placement='top' title={item?.department} arrow>
                                                    <div style={{ fontSize: "0.875rem" }}>{item?.department?.slice(0, 8) + "..."}</div></Tooltip> :
                                                item?.department : "-"}
                                        </TableCell>
                                        <TableCell align='center' emed_tid="bill_dosage_type" sx={{ flex: 0.083, paddingTop: '0.8vw' }}>
                                            {CategoryName ? CategoryName?.length > 8 ?
                                                <Tooltip placement='top' title={CategoryName} arrow>
                                                    <div style={{ fontSize: "0.875rem" }}>{CategoryName?.slice(0, 8) + "..."}</div></Tooltip> :
                                                CategoryName : "-"}
                                        </TableCell>
                                        <TableCell align='center' emed_tid="bill_dosage_strength" sx={{ flex: 0.10, paddingTop: '0.8vw' }} className='eMed_Pharma_tbl_Body'>
                                            {item?.product_type ? item?.product_type?.length > 8 ?
                                                <Tooltip placement='top' title={item?.product_type} arrow>
                                                    <div style={{ fontSize: "0.875rem" }}>{item?.product_type?.slice(0, 8) + "..."}</div></Tooltip> :
                                                item?.product_type : "-"}
                                        </TableCell>
                                        <TableCell sx={{ flex: 0.12 }}>
                                            {renderBatchColumn(index, item)}
                                        </TableCell>
                                        <TableCell align='center' sx={{ flex: 0.08, paddingTop: '0.8vw' }}>{ExpiryDate}</TableCell>
                                        <TableCell align='center' sx={{ flex: 0.08, paddingTop: '0.8vw' }}>{item?.buying_price_per_quantity ? item?.buying_price_per_quantity : '-'}</TableCell>
                                        <TableCell align='center' sx={{ flex: 0.09, paddingTop: '0.8vw' }}>{item?.available_qty ? item?.available_qty : '0'}</TableCell>
                                        <TableCell align='center' sx={{ flex: 0.09, paddingTop: '0.8vw' }}>{inputTextBox(item?.quantity, 'quantity', 'Qty', '3vw', index)}</TableCell>
                                        <TableCell sx={{ flex: 0.09 }} align='center'>
                                            {inputTextBox(item?.discount_percentage, 'discount_percentage', 'Discount', '3vw', index)}
                                        </TableCell>
                                        <TableCell sx={{ flex: 0.09 }} align='center'>
                                            {inputTextBox(item?.discount_amount, 'discount_amount', 'Amount', '3vw', index)}
                                        </TableCell>
                                        <TableCell emed_tid="bill_total_price" align='center' sx={{ flex: 0.09, paddingTop: '0.8vw' }}>{item?.total_price ? (item?.total_price).toFixed(2) : '0'}</TableCell>
                                    </TableRow>
                                </Tooltip>)
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box component={'div'} height={'8vw'} className='eMed_Phrama_Table_Container'>
                <Box component={'div'} display={'flex'} marginLeft={'69vw'}>
                    <Box component={'div'}>
                        <Box component={'div'} className='eMed_bill_tbl_footer' marginBottom={'1vw'}>
                            <Typography mt={0.5} fontSize={'0.9vw'} fontWeight='600'>{"Round Off"}</Typography>
                            <Typography emed_tid="total_net_amount" mt={0.5} mr={'0.8vw'} fontWeight='600'>{billingCalculation(productTblData, 'roundOff')}</Typography>
                        </Box>
                        {/* <Box component={'div'} className='eMed_bill_tbl_footer' marginBottom={'1vw'}>
                            <Typography mt={0.5} fontSize={'0.9vw'} fontWeight='600'>{"Taxable Amount"}</Typography>
                            <Typography emed_tid="total_net_amount" mt={0.5} mr={'0.8vw'} fontWeight='600'>{billingCalculation(productTblData, 'Taxamount')}</Typography>
                        </Box> */}
                        <Box component={'div'} className='eMed_bill_tbl_footer'>
                            <Typography mt={0.5} fontSize={'0.9vw'} fontWeight='600'>{"Net Amount"}</Typography>
                            <Typography emed_tid="total_net_amount" mt={0.5} mr={'0.8vw'} fontWeight='600'>{billingCalculation(productTblData, 'totalServiceAmount')}</Typography>
                        </Box>
                    </Box>
                </Box>
                <Box component={'div'} display={'flex'} sx={{ backgroundColor: Colors.Background, marginTop: '0.5vw' }}>
                    <Box display={'flex'} marginLeft={'75vw'} visibility={(isEdit || !CheckAccessFunc("Store", "Purchase", "Purchase Rejection", null, "Tab")?.editAccess) ? 'hidden' : "visible"}>
                        <Button emed_tid="bill_clear_btn" sx={{ margin: '0.5vw 1vw 0.5vw 0vw', textTransform: 'capitalize' }}
                            size='small'
                            variant='outlined'
                            onClick={() => {
                                clearfunction()
                            }}
                        >Clear</Button>
                        <Button emed_tid="bill_receive_payment_btn" sx={{ margin: '0.5vw 1vw 0.5vw 0vw', textTransform: 'capitalize', width: "10vw" }}
                            size='small'
                            variant='contained'
                            onClick={() => {
                                let isValid = true;
                                for (let item of productTblData) {
                                    if (+item?.available_qty < +item?.quantity && item?.batch_no && item?.quantity) {
                                        isValid = false;
                                        errorMessage("Please select valid quantity for " + item?.product_name);
                                        break;
                                    }
                                }
                                if (isValid) {
                                    postPurchaseReturn()
                                }
                            }}
                        >Finish</Button>
                    </Box>
                </Box>
            </Box>
            {isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={isErrorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={SuccessMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default StorePurchaseRejectionAdd;
